import AssetHelper from "first-common/AssetHelper";
import { Howl, Howler } from 'howler';
import canAutoplay from 'can-autoplay';

export type MatchSound = 'matchStart' | 'autoEnd' | 'controllers' | 'countdown' | 'startTeleop' | 'endgameWarning' |
    'matchEnd' | 'abortMatch' | 'unmute' | 'results'

let sounds : Record<MatchSound, Howl> | null = null;
let unlocked = true;

export function initSounds() {
    if(sounds) return;
    sounds = {
        matchStart: new Howl({src: AssetHelper.syncPath('audio/charge.wav')}),
        autoEnd: new Howl({src: AssetHelper.syncPath('audio/endauto.wav')}),
        controllers: new Howl({src: AssetHelper.syncPath('audio/Pick_Up_Controllers_2s.wav')}),
        countdown: new Howl({src: AssetHelper.syncPath('audio/3-2-1.wav')}),
        startTeleop: new Howl({src: AssetHelper.syncPath('audio/firebell.wav')}),
        endgameWarning: new Howl({src: AssetHelper.syncPath('audio/factwhistle.wav')}),
        matchEnd: new Howl({src: AssetHelper.syncPath('audio/endmatch.wav')}),
        abortMatch: new Howl({src: AssetHelper.syncPath('audio/fogblast.wav')}),
        unmute: new Howl({src: AssetHelper.syncPath('audio/unmute.wav')}),
        results: new Howl({src: AssetHelper.syncPath('audio/results.wav')})
    }

    canAutoplay.audio().then(({result}) => {
        unlocked = result;
    })
    sounds.unmute.on('unlock', () => {
        unlocked = true;
    })
}

export default function play(sound : MatchSound) {
    if(!sounds) {
        console.error(`Tried to play sound '${sound}', but sounds must be initialized first`)
        return;
    }
    if(!unlocked) {
        console.log(`Tried to play sound '${sound}', but user interaction is required first`)
        return;
    }
    // Don't allow concurrent sounds
    Howler.stop()
    sounds[sound].play()
}

export function getSound(sound : MatchSound) {
    if(!sounds) {
        console.error(`Tried to get sound '${sound}', but sounds must be initialized first`)
        return;
    }
    return sounds[sound]
}